import { render, staticRenderFns } from "./MarketplaceProduct.vue?vue&type=template&id=40d1905e&scoped=true"
import script from "./MarketplaceProduct.vue?vue&type=script&lang=js"
export * from "./MarketplaceProduct.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceProduct.vue?vue&type=style&index=0&id=40d1905e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d1905e",
  null
  
)

export default component.exports